import {createStore, combineReducers, compose} from 'redux';
import language from './language';
import manageBgValue from './cellValue';
import mata from './mataToShare';
import game1 from './game1';
import game1Click from './game1Click';
import rightMenuExpanded from './rightMenuExpanded'
import activeTable from './activeTable';
import krazki from './krazki';
import squaresState from './tableSquaresState';
import circlesState from './tableCirclesState';
import matas from './getMatas';
import mataUrl from './mataUrl';
import setAlert from './setAlert';

const silencer = (state = 1) => {
    return state;
};
const commands = (state = [
    ['aj', 'aj', 'aj', 'aj', 'aj', 'aj', 'aj', 'aj', 'aj', 'aj', 'aj'],
    ['aj', 'aj', 'aj', 'aj', 'aj', 'aj', 'aj', 'aj', 'aj', 'aj', 'aj']
]) => {
  return state;
};

const reducer = combineReducers({
    commands,
    silencer,
    setAlert,
    language: language,
    activeTable,
    mataUrl,
    squaresState,
    circlesState,
    krazki,
    rightMenuExpanded,
    manageBgValue: manageBgValue,
    game1,
    matas,
    game1Click,
    mataSquares: mata('mata-squares'),
    mataCircles: mata('mata-circles'),
    mata3: mata('mata3'),
});

let persistedState;
if (window.mapHash) {
    persistedState = window.mapHash;
} else {
    persistedState = localStorage.getItem('mataState') ? JSON.parse(localStorage.getItem('mataState')) : {};
}
if (!persistedState && !persistedState.squaresState.commands) {
    persistedState.squaresState.commands = [
        ['aj', 'aj', 'aj', 'aj', 'aj', 'aj', 'aj', 'aj', 'aj', 'aj', 'aj'],
        ['aj', 'aj', 'aj', 'aj', 'aj', 'aj', 'aj', 'aj', 'aj', 'aj', 'aj']
    ]
}

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(reducer, persistedState,
    composeEnhancers()
);
store.subscribe(() => {
    let curState = store.getState();
    localStorage.setItem('mataState', JSON.stringify(Object.assign({}, {
        squaresState: curState['squaresState'],
        circlesState: curState['circlesState'],
        // commands: curState['commands']
    })))
});

export default store


// WEBPACK FOOTER //
// ./src/state/store.js